(() => {
  if (window.RG_CART_SHIPPING_INITIALIZED) return;
  window.RG_CART_SHIPPING_INITIALIZED = true;
  const thresholdCents = 4990;
  const context = window.RG_SHOP_CONTEXT || {};
  const country = String(context.country || '').toUpperCase();
  const language = String(context.language || document.documentElement.lang || 'es').toLowerCase();
  const currency = String(context.currency || 'EUR').toUpperCase();
  const root = String(context.root || window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const copy = context.shipping || {};
  const eligible = context.isB2B !== true && country === 'ES' && currency === 'EUR';
  let refreshTimer;
  let requestVersion = 0;

  const formatMoney = (cents) => new Intl.NumberFormat(language.startsWith('en') ? 'en-GB' : 'es-ES', {
    style: 'currency', currency: 'EUR'
  }).format(cents / 100);

  const createProgress = () => {
    const wrapper = document.createElement('div');
    wrapper.className = 'rg-free-shipping-progress';
    wrapper.setAttribute('role', 'status');
    const status = document.createElement('strong');
    status.className = 'rg-free-shipping-progress__status';
    const track = document.createElement('div');
    track.className = 'rg-free-shipping-progress__track';
    track.setAttribute('aria-hidden', 'true');
    const bar = document.createElement('span');
    bar.className = 'rg-free-shipping-progress__bar';
    track.append(bar);
    const extras = document.createElement('p');
    extras.className = 'rg-free-shipping-progress__extras';
    wrapper.append(status, track, extras);
    return wrapper;
  };

  const ensureProgress = (container) => {
    if (!container || !eligible) return null;
    const bars = [...container.querySelectorAll(':scope > .rg-free-shipping-progress')];
    bars.slice(1).forEach(bar => bar.remove());
    const progress = bars[0] || createProgress();
    if (!bars.length) container.prepend(progress);
    return progress;
  };

  const setExtras = (container) => {
    const label = document.createTextNode(`${copy.extras || ''} `);
    const wraps = document.createElement('a');
    wraps.href = `${root}collections/vendas-de-boxeo`;
    wraps.textContent = copy.wraps || '';
    const separator = document.createTextNode(' · ');
    const mouthguards = document.createElement('a');
    mouthguards.href = `${root}collections/protector-bucal`;
    mouthguards.textContent = copy.mouthguards || '';
    container.replaceChildren(label, wraps, separator, mouthguards);
  };

  const updateProgress = (progress, cart) => {
    if (!progress || !cart || !eligible) return;
    progress.hidden = !cart.item_count;
    if (progress.hidden) return;
    const status = progress.querySelector('.rg-free-shipping-progress__status');
    const bar = progress.querySelector('.rg-free-shipping-progress__bar');
    const extras = progress.querySelector('.rg-free-shipping-progress__extras');
    const total = Math.max(Number(cart.total_price || 0), 0);
    const remaining = Math.max(thresholdCents - total, 0);
    bar.style.width = `${Math.min((total / thresholdCents) * 100, 100)}%`;
    status.textContent = remaining === 0 ? copy.reached || '' : String(copy.remaining || '').replace('__RG_AMOUNT__', formatMoney(remaining));
    extras.hidden = remaining === 0;
    if (remaining === 0) extras.replaceChildren();
    else setExtras(extras);
  };

  const render = (cart) => {
    if (!eligible) {
      document.querySelectorAll('.rg-free-shipping-progress').forEach(node => node.remove());
      return;
    }
    const containers = [
      document.querySelector('#cart-notification .cart-notification__links'),
      document.querySelector('#main-cart-footer .cart__blocks'),
      document.querySelector('#CartDrawer .drawer__footer')
    ];
    containers.forEach(container => updateProgress(ensureProgress(container), cart));
  };

  const refresh = async () => {
    const version = ++requestVersion;
    if (!eligible) return render(null);
    try {
      const cartUrl = `${window.routes?.cart_url || root + 'cart'}.js`;
      const response = await fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (version === requestVersion) render(cart);
    } catch (error) {}
  };

  const scheduleRefresh = (delay = 80) => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, delay);
  };

  const init = () => {
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => scheduleRefresh(50));
    }
    document.addEventListener('change', (event) => {
      if (event.target instanceof Element && event.target.closest('cart-items, cart-drawer-items')) scheduleRefresh(450);
    });
    document.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('quantity-input, cart-remove-button')) scheduleRefresh(550);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
